export const board_size = 15;
